module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('fragment', [_c('tr', {
    staticStyle: {
      "border-top": "1px solid #eee"
    }
  }, [_c('td', {
    staticClass: "align-middle"
  }, [_vm._v(_vm._s(_vm.shipIndex + 1))]), _vm._v(" "), _c('td', {
    staticClass: "align-middle squeeze"
  }, [_c('div')]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.row.description),
      expression: "row.description"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "sparse-text",
    attrs: {
      "disabled": _vm.readOnly,
      "type": "text",
      "id": 'tertiaryDesc' + _vm.shipIndex,
      "autocapitalize": "off",
      "autocomplete": "off",
      "autocorrect": "off",
      "autofocus": "",
      "role": "combobox",
      "spellcheck": "false",
      "placeholder": "description..."
    },
    domProps: {
      "value": (_vm.row.description)
    },
    on: {
      "keyup": _vm.productLiveSearch,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.row, "description", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.productrows && _vm.productrows.length),
      expression: "productrows && productrows.length"
    }],
    staticClass: "customLiveSearch",
    staticStyle: {
      "max-width": "240px"
    },
    attrs: {
      "id": 'tertiaryDesc' + _vm.shipIndex + 'auto'
    }
  }, [_vm._l((_vm.productrows), function(product, pIdx) {
    return [_c('div', {
      key: pIdx,
      staticClass: "customLiveSearchElement",
      on: {
        "click": function($event) {
          return _vm.productSelected(product)
        }
      }
    }, [_vm._v(_vm._s(product.description))])]
  })], 2)]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.row.lot),
      expression: "row.lot"
    }],
    staticClass: "sparse-text",
    attrs: {
      "type": "text",
      "id": 'tertiaryLot' + _vm.shipIndex,
      "autocapitalize": "off",
      "autocomplete": "off",
      "autocorrect": "off",
      "autofocus": "",
      "role": "combobox",
      "spellcheck": "false",
      "placeholder": "lot number...",
      "disabled": _vm.readOnly
    },
    domProps: {
      "value": (_vm.row.lot)
    },
    on: {
      "keyup": function($event) {
        return _vm.lotLiveSearch($event, _vm.row)
      },
      "click": function($event) {
        return _vm.showLots($event, _vm.row)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.row, "lot", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lotRows.length > 0),
      expression: "lotRows.length > 0"
    }],
    staticClass: "customLiveSearch",
    staticStyle: {
      "max-width": "240px"
    },
    attrs: {
      "id": 'tertiaryLot' + _vm.shipIndex + 'auto'
    }
  }, [_vm._l((_vm.lotRows), function(lot, lIdx) {
    return [_c('div', {
      key: lIdx,
      staticClass: "customLiveSearchElement",
      on: {
        "click": function($event) {
          return _vm.lotSelected(_vm.row, lot)
        }
      }
    }, [_vm._v(_vm._s(lot.name + ' (' + lot.available + ')'))])]
  })], 2)]), _vm._v(" "), _c('td', {
    staticClass: "text-center align-middle"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.row.quantity),
      expression: "row.quantity"
    }],
    staticClass: "sparse-text expander",
    attrs: {
      "disabled": _vm.readOnly,
      "type": "text"
    },
    domProps: {
      "value": (_vm.row.quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.row, "quantity", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "text-center align-middle",
    attrs: {
      "title": _vm.row.type + ': ' + _vm.row.apiIntegration + ' -- ' + _vm.row.internalId
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.row.stackable),
      expression: "row.stackable"
    }],
    staticClass: "form-control form-control-sm sparse-text",
    attrs: {
      "disabled": _vm.readOnly
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.row, "stackable", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No")])])]), _vm._v(" "), _c('td', {
    staticClass: "text-center align-middle"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.row.length),
      expression: "row.length"
    }],
    staticClass: "sparse-text expander",
    attrs: {
      "disabled": _vm.readOnly,
      "type": "text"
    },
    domProps: {
      "value": (_vm.row.length)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.row, "length", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "text-center align-middle"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.row.width),
      expression: "row.width"
    }],
    staticClass: "sparse-text expander",
    attrs: {
      "disabled": _vm.readOnly,
      "type": "text"
    },
    domProps: {
      "value": (_vm.row.width)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.row, "width", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "text-center align-middle"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.row.height),
      expression: "row.height"
    }],
    staticClass: "sparse-text expander",
    attrs: {
      "disabled": _vm.readOnly,
      "type": "text"
    },
    domProps: {
      "value": (_vm.row.height)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.row, "height", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "text-center align-middle"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.row.weight),
      expression: "row.weight"
    }],
    staticClass: "sparse-text expander",
    attrs: {
      "disabled": _vm.readOnly,
      "type": "text"
    },
    domProps: {
      "value": (_vm.row.weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.row, "weight", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "text-center align-middle"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.row.hazardous),
      expression: "row.hazardous"
    }],
    staticClass: "form-control form-control-sm sparse-text expander",
    attrs: {
      "disabled": _vm.readOnly
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.row, "hazardous", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No")])])]), _vm._v(" "), _c('td', [_c('button', {
    class: 'btn btn-sm btn-block text-left text-nowrap ' + (this.expanded ? _vm.row.components.find(function (c) { return c.expanded; }) ? 'btn-primary-inactive' : 'btn-primary-inactive' : 'btn-secondary'),
    attrs: {
      "type": "button",
      "disabled": _vm.row.type == 'None'
    },
    on: {
      "click": _vm.onUnitsExpand
    }
  }, [_c('span', {
    staticClass: "d-block "
  }, [_vm._v("\n                " + _vm._s(_vm.numSecondaryUnits || '---') + "\n                "), (_vm.row.type != 'None') ? _c('span', {
    staticClass: "float-right"
  }, [_c('i', {
    class: _vm.expanded ? 'fa fa-chevron-up spinEffect' : 'fa fa-chevron-down spinEffectReverse'
  })]) : _vm._e()])])]), _vm._v(" "), _c('td', {
    staticClass: "align-middle text-nowrap"
  }, [(!_vm.readOnly) ? _c('a', {
    staticClass: "text-body",
    on: {
      "click": _vm.cloneRow
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-copy"
  })]) : _vm._e(), _vm._v(" "), (!_vm.readOnly) ? _c('a', {
    staticClass: "text-danger",
    on: {
      "click": _vm.removeRow
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-times"
  })]) : _vm._e()])]), _vm._v(" "), _vm._l((this.row.components), function(unit, unitIndex) {
    return [_c('SecondaryRow', {
      key: 'secondary_' + unitIndex,
      attrs: {
        "customerCompanyEntity": _vm.customerCompanyEntity,
        "unit": unit,
        "unitIndex": unitIndex,
        "show": _vm.expanded,
        "rowIndex": _vm.shipIndex,
        "readOnly": _vm.readOnly
      },
      on: {
        "removeUnit": function($event) {
          return _vm.removeUnit(unitIndex)
        },
        "cloneUnit": function($event) {
          return _vm.duplicateUnit(unit, unitIndex)
        }
      }
    })]
  }), _vm._v(" "), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.expanded),
      expression: "expanded"
    }],
    key: 'secondary_unit_add' + _vm.shipIndex,
    staticClass: "bg-gray"
  }, [_c('td', {
    staticClass: "bg-white border-0",
    attrs: {
      "colspan": "2"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "text-right",
    attrs: {
      "colspan": "11"
    }
  }, [(!_vm.readOnly) ? _c('button', {
    staticClass: "btn btn-clear",
    on: {
      "click": _vm.addSecondaryUnit
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle"
  }), _vm._v(" ADD ROW")]) : _vm._e()])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-756754c1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shippinglvls/TertiaryRow.vue
// module id = 740
// module chunks = 0